module.exports = __webpack_public_path__ + "img/portfolio.8008bc2.png";